export const HeartFilledIcon = ({ className }: { className?: string }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6094 2C14.0342 2.0002 16 3.93931 16 6.33008C16 8.93401 14.0556 11.3918 10.2256 13.6387L7.90332 15L5.625 13.5684C0.000272134 10.0344 7.82563e-10 7.24641 0 6.33008C0 3.9393 1.96481 2.00019 4.38965 2C5.88565 2 7.207 2.73784 8 3.86523C8.793 2.73784 10.1134 2 11.6094 2Z"
      fill="currentColor"
    />
  </svg>
);
